const PHRASES = ["Understand", "Reset", "Reconnect", "Reclaim", "Sanctuary", "Clarity"];

export const Marquee = () => {
  const line = [...PHRASES, ...PHRASES];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[rgba(163,74,107,0.15)] bg-[#F4E8E4] py-6">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {line.map((word, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-8 font-serif text-2xl italic text-cream/70 sm:text-3xl">{word}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#A34A6B]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
